module.exports = __webpack_public_path__ + "assets/img/202107-1W.9a23588a.png";